import { Grid } from '@material-ui/core';

// local imports
import { useInputChangeHandler } from 'app/hooks';
import { FormatUtils } from 'app/utils';
import { isValid } from 'date-fns';
import { AsyncButton, FormInput, AddPhoto, FormDatePicker, FormSwitch } from '../../atoms';

const CampaignCrudForm = ({
  isEdit,
  loading,
  selectedFiles,
  setSelectedFiles,
  removeFile,
  // handleDelete,
  deleteLoading
}) => {
  const { values } = useInputChangeHandler();

  // variables
  const btnText = isEdit ? 'Kampanyayı Güncelle' : 'Kampanya Oluştur';
  const btnIcon = isEdit ? 'update' : 'add';
  const chooseMinDate = !isEdit && new Date();
  const startDateValid = isValid(values?.start_date) ? values?.start_date : null;
  const startDateMsg = `Bu tarihten öncesi olamaz! (${FormatUtils.convertPostDate(new Date())})`;
  const endDateMsg = `Bu tarihten öncesi olamaz! 
  (${FormatUtils.convertPostDate(startDateValid || new Date())})`;

  return (
    <div className="pt-8">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <FormDatePicker
            id="campaign_start_date"
            name="start_date"
            label="Başlangıç Tarihi"
            value={values?.start_date || ''}
            minDate={chooseMinDate}
            minDateMessage={startDateMsg}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} xl={3}>
          <FormDatePicker
            id="campaign_end_date"
            name="end_date"
            label="Bitiş Tarihi"
            value={values?.end_date || ''}
            minDate={values?.start_date || new Date()}
            minDateMessage={endDateMsg}
            disabled={loading}
          />
        </Grid>

        <Grid container item direction="row" xs={12} md={4} xl={3}>
          <Grid item xs={12} className="text-gray-700 font-semibold">
            Bildirim Seçenekleri
          </Grid>
          <Grid item xs={4}>
            <FormSwitch
              disabled={loading}
              checked={values?.sms_notification_enabled}
              name="sms_notification_enabled"
              label="SMS"
            />
          </Grid>
          <Grid item xs={4}>
            <FormSwitch
              disabled={loading}
              checked={values?.email_notification_enabled}
              name="email_notification_enabled"
              label="Email"
            />
          </Grid>
          <Grid item xs={4}>
            <FormSwitch
              disabled={loading}
              checked={values?.push_notification_enabled}
              name="push_notification_enabled"
              label="Push"
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormInput
            multiline
            rows={6}
            id="campaign_name"
            name="name"
            label="Kampanya Adı"
            placeholder="Kampanya Adı"
            disabled={loading}
            value={values?.name || ''}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormInput
            multiline
            rows={6}
            id="campaign_description"
            name="description"
            label="Ürün Bilgisi / Açıklama"
            placeholder="Ürün Bilgisi / Açıklama"
            disabled={loading}
            value={values?.description || ''}
            maxLength={255}
          />
        </Grid>

        {/* Photo - Action Buttons */}
        <Grid item xs={12}>
          <AddPhoto
            id="campaign_photo"
            label="Kampanya Görseli"
            loading={loading}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            name="content"
            removeFile={removeFile}
          />
        </Grid>

        {/* Action buttons */}
        <Grid item xs={12} className="flex justify-end">
          {/* {isEdit && (
            <AsyncButton
              disabled={loading || deleteLoading}
              icon="cancel"
              text="Kampanyayı Bitir"
              type="button"
              loading={deleteLoading}
              handleClick={handleDelete}
              className="bg-red-400 text-white hover:bg-red-600 mr-16"
            />
          )} */}
          <AsyncButton
            icon={btnIcon}
            text={btnText}
            loading={loading}
            className="bg-green-400 text-white hover:bg-green-600"
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CampaignCrudForm;
